import { useEffect, useRef, type ReactNode } from 'react'
import { posthog, initPostHog } from '@/lib/posthog'
import { useAuth } from '@/hooks/useAuth'

export function PostHogProvider({ children }: { children: ReactNode }) {
  const { user } = useAuth()
  const previousUserId = useRef<string | null>(null)

  useEffect(() => {
    initPostHog()
  }, [])

  useEffect(() => {
    if (user) {
      posthog.identify(user.id, { email: user.email })
      previousUserId.current = user.id
    } else if (previousUserId.current) {
      posthog.reset()
      previousUserId.current = null
    }
  }, [user])

  return <>{children}</>
}
